import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { Alert, InputAdornment, Modal, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import resetSuccess from "../../../assets/images/linkSuccessful.png";
import OnBoardImage from "../../../assets/images/onboard-one.png";
import permssionError from "../../../assets/images/permissionError.png";
import resetLinkSent from "../../../assets/images/resetLinkSent.svg";
import UNIVERSAL from "../../../config/config";
import ZocketLogo from "../Login/zocketLogo/ZocketLogo";
import {
  Btn,
  FormHeader,
  Input,
  InputField,
  Left,
  LeftContent,
  LinkSentModal,
  LinkSentModalBottom,
  Logo,
  Para,
  ResetPasswordWrapper,
  Right,
  RightDetail,
  Wrapper,
} from "./Resetpassword.styles";

const ResetPassword = () => {
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rePassword, setRePassword] = useState("");
  const [step, setStep] = useState(1);
  const [errorToast, setErrorToast] = useState("");
  const [linkSentModal, setLinkSentModal] = useState(false);
  const [wrongCodeModal, setWrongCodeModal] = useState(false);
  const [resetSuccessModal, setResetSuccessModal] = useState(false);

  const navigate = useNavigate();

  const get_reset_link = () => {
    if (!email) {
      return setErrorToast("Please provide email address.");
    }
    setStep(2);
  };

  useEffect(() => {
    if (errorToast) setErrorToast("");
  }, [password, rePassword]);

  const do_reset_password = async () => {
    if (!password || !rePassword) {
      return setErrorToast("Please provide password.");
    } else if (password !== rePassword) {
      setErrorToast("Confirm password should be same as password.");
      return;
    } else {
      const response = await fetch(UNIVERSAL.BASEURL_2 + "/auth/api/v1/set-new-password-email", {
        method: "POST",
        body: JSON.stringify({ email, password }),
        headers: { "Content-Type": "application/json" },
      });
      if (response.ok) {
        setResetSuccessModal(true);
        setTimeout(() => navigate("/auth/login"), 3500);
      } else {
        const data = await response.json();
        toast(data.message ?? "Unable to reset password! Something went wrong, please try again!", { type: "error" });
      }
    }
  };

  return (
    <Wrapper>
      <Left>
        <LeftContent>
          <Logo>
            <ZocketLogo width="4rem" initialPos="140" />
            <h2>Zocket</h2>
          </Logo>
          <Stack>
            <img src={OnBoardImage} width="100%" height="100%" style={{ maxHeight: 500, objectFit: "cover" }} />
          </Stack>
          <Stack direction="column">
            <Typography variant="h5" fontWeight={600} color="black" textAlign="center">
              Set rules and get notified
            </Typography>
            <Typography color="black" textAlign="center">
              Get notifications when the ad is dipping after the rules are set
            </Typography>
          </Stack>
        </LeftContent>
      </Left>
      <Right>
        <RightDetail>
          <Logo>
            <h2>Zocket</h2>
          </Logo>
          <h2>
            Welcome to our&nbsp;<FormHeader>Dashboard</FormHeader>
          </h2>
          <Para>See all the analytics and grow your data remotely, from anywhere!</Para>
        </RightDetail>
        <ResetPasswordWrapper>
          {step === 1 && (
            <>
              <FormHeader>Reset your password</FormHeader>
              <Para>Provide your email for reset link.</Para>
              {errorToast && (
                <Alert sx={{ marginBottom: "1rem" }} severity="warning">
                  {errorToast}
                </Alert>
              )}
              <Input>
                <InputField label="Email Address" value={email} onChange={(e) => setEmail(e.target.value)} type="email" />
              </Input>

              <Btn onClick={() => get_reset_link()} variant="contained" fullWidth>
                Continue
              </Btn>
            </>
          )}

          {step === 2 && (
            <>
              <FormHeader>Reset your password</FormHeader>
              <Para>Set the new password for your account, so you can login and access all the features</Para>
              {errorToast && (
                <Alert sx={{ marginBottom: "1rem" }} severity="warning">
                  {errorToast}
                </Alert>
              )}
              <Input>
                <InputField label="Password" value={password} onChange={(e) => setPassword(e.target.value)} type="password" />
              </Input>
              <Input>
                <InputField
                  label="Confirm Password"
                  value={rePassword}
                  onChange={(e) => setRePassword(e.target.value)}
                  type={passwordVisible ? "text" : "password"}
                  fullWidth
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" style={{ cursor: "pointer" }} onClick={() => setPasswordVisible(!passwordVisible)}>
                        {passwordVisible ? <VisibilityOffIcon /> : <VisibilityIcon />}
                      </InputAdornment>
                    ),
                  }}
                />
              </Input>
              <Btn onClick={() => do_reset_password()} variant="contained" fullWidth>
                Reset password
              </Btn>
            </>
          )}
        </ResetPasswordWrapper>
      </Right>
      <Modal open={linkSentModal} onClose={() => setLinkSentModal(false)}>
        <LinkSentModal>
          <img src={resetLinkSent} />
          <LinkSentModalBottom>
            <FormHeader>Reset link has been sent</FormHeader>
            <Para>Check your mail for the reset link and change the password</Para>
          </LinkSentModalBottom>
        </LinkSentModal>
      </Modal>
      <Modal open={wrongCodeModal} onClose={() => setWrongCodeModal(false)}>
        <LinkSentModal>
          <img src={permssionError} />
          <LinkSentModalBottom>
            <FormHeader>Not a valid URL</FormHeader>
            <Para>The reset link is not valid please try again.</Para>
          </LinkSentModalBottom>
        </LinkSentModal>
      </Modal>
      <Modal open={resetSuccessModal} onClose={() => navigate("/")}>
        <LinkSentModal>
          <img src={resetSuccess} />
          <LinkSentModalBottom>
            <FormHeader>Password reset successful</FormHeader>
            <Para>You have successfully reset you password. Login with your new password.</Para>
          </LinkSentModalBottom>
        </LinkSentModal>
      </Modal>
    </Wrapper>
  );
};

export default ResetPassword;
